module.exports = __webpack_public_path__ + "51b43a6d534ca105185c7343c2b6aa6a.MP3";